import { render, staticRenderFns } from "./MockExamSubjects.vue?vue&type=template&id=b538dc1a"
import script from "./MockExamSubjects.vue?vue&type=script&lang=js"
export * from "./MockExamSubjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports